export default __webpack_public_path__ + "static/media/card_dexpro1.0e89e78d.png";